module.exports = "\n<div class=\"comp-lightbox-item\">\n  <div class=\"comp-lightbox-item-thumb\" v-if=\"thumbUrl\" v-on:click.prevent=\"onClick\"><img :src=\"thumbUrl\" :alt=\"title\" :class=\"[hasPreviewShadow ? 'img-shadow' : '']\">\n    <p class=\"caption\" v-if=\"isPreviewCaptionVisible\">{{ title }}</p>\n  </div>\n  <slot></slot>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/lightbox_item/index.pug
// module id = 668
// module chunks = 4